enum GameOverState {
    unauthorized = 'unauthorized',
    authorized = 'authorized',
    shared = 'shared',
}

export default GameOverState
